import { stationsActions } from '../reducer';

import { StationsState } from '../../types';

export const updateStations = (stations?: StationsState['stations']['data']) => stationsActions
  .updateStations(stations);
